function directive() {
  return {
    restrict: 'E',
    scope: {
      filter: '='
    },
    template:
      `<div ng-repeat="type in kinds">
        <label>
         <input type="radio" name="searchKind" ng-model="filter.value" ng-change="update()" ng-value="type.id"> {{type.name}}
        </label>
      </div>`,
    controller: [
      '$scope',
      '$translate',
      ($scope, $translate) => {
        $scope.kinds = [
          { name: $translate.instant('WEBSKED_DATE'), id: 'time' },
          { name: $translate.instant('CREATED_DATE'), id: 'created' },
          { name: $translate.instant('LAST_UPDATED_DATE'), id: 'updated' },
          { name: $translate.instant('RELEVANCE'), id: 'relevance' }
        ];

        $scope.update = () => {
          $scope.filter.changeValue($scope.filter.value);
        };
      }]
  };
}

export default function (ngModule) {
  ngModule.directive('refineSearchKind', directive);
}
